"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const invariant = require("invariant");
const React = require("react");
const util_1 = require("util");
class Library {
    constructor(css, js) {
        this.css = css;
        this.js = js;
    }
    add(lib) {
        let jsUrls = [];
        let cssUrls = [];
        if (!util_1.isNullOrUndefined(this.js)) {
            if (this.js instanceof Array) {
                jsUrls = jsUrls.concat(this.js);
            } else {
                jsUrls.push(this.js);
            }
        }
        if (!util_1.isNullOrUndefined(lib.js)) {
            if (lib.js instanceof Array) {
                jsUrls = jsUrls.concat(lib.js);
            } else {
                jsUrls.push(lib.js);
            }
        }
        if (!util_1.isNullOrUndefined(this.css)) {
            if (this.css instanceof Array) {
                cssUrls = cssUrls.concat(this.css);
            } else {
                cssUrls.push(this.css);
            }
        }
        if (!util_1.isNullOrUndefined(lib.css)) {
            if (lib.css instanceof Array) {
                cssUrls = cssUrls.concat(lib.css);
            } else {
                cssUrls.push(lib.css);
            }
        }
        return new Library(cssUrls, jsUrls);
    }
}
exports.Library = Library;
class Loader extends React.Component {
    constructor(props) {
        super(props);
        this.libraries = new Library([], []);
        this.loadedCount = 0;
        this.scriptLoaderId = `id${Loader.idCount++}`; // eslint-disable-line space-unary-ops
        if (this.props.libraries instanceof Array) {
            this.props.libraries.forEach(library => {
                this.libraries = this.libraries.add(library);
            });
        } else {
            this.libraries = this.props.libraries;
        }
    }
    localOnLoad(url) {
        this.loadedCount++;
        Loader.loadedScripts[url] = true;
        if (this.loadedCount < this.libraries.js.length) {
            this.handleScript(this.libraries.js[this.loadedCount]);
        } else {
            this.props.onLoad();
        }
    }
    localOnError() {
        this.loadedCount++;
        if (this.loadedCount < this.libraries.js.length) {
            this.handleScript(this.libraries.js[this.loadedCount]);
        } else {
            this.props.onLoad();
        }
    }
    componentDidMount() {
        const { js } = this.libraries;
        if (js instanceof Array) {
            if (js.length > 0) {
                this.handleScript(js[this.loadedCount]);
            } else {
                this.props.onLoad();
            }
        } else {
            this.handleScript(js);
        }
    }
    handleScript(url) {
        if (Loader.loadedScripts[url]) {
            this.localOnLoad(url);
            return;
        }
        if (Loader.loadingScripts[url]) {
            return;
        }
        Loader.loadingScripts[url] = true;
        this.createScript(url);
    }
    createScript(url) {
        const script = document.createElement("script");
        script.src = url;
        script.async = true;
        script.onload = () => {
            this.localOnLoad(url);
        };
        script.onerror = () => {
            this.localOnError();
        };
        document.body.appendChild(script);
    }
    runCallback(type, required = true) {
        const callback = this.props.onLoad;
        invariant(!required || typeof callback === "function", `Callback ${type} must be function, got "${typeof callback}" instead`);
        return callback && callback();
    }
    generateCssLinks() {
        const { css } = this.libraries;
        if (util_1.isNullOrUndefined(css)) {
            return null;
        } else {
            let cssLinks = [];
            if (css instanceof Array) {
                cssLinks = css.map(cssLink => {
                    let type = "stylesheet";
                    if (cssLink.endsWith(".scss")) {
                        type = "stylesheet/scss";
                    }
                    return React.createElement("link", { key: "stylesheet-" + Loader.idStyleCount++, href: cssLink, rel: type });
                });
            } else if (typeof css === "string") {
                let type = "stylesheet";
                if (css.endsWith(".scss")) {
                    type = "stylesheet/scss";
                }
                cssLinks.push(React.createElement("link", { key: "stylesheet-" + Loader.idStyleCount++, href: css, rel: type }));
            }
            return React.createElement("div", null, cssLinks);
        }
    }
    render() {
        return this.generateCssLinks();
    }
}
Loader.loadingScripts = {};
Loader.loadedScripts = {};
Loader.idCount = 0;
Loader.idStyleCount = 0;
exports.default = Loader;


//////////////////
// WEBPACK FOOTER
// ./client/src/shared/Loader.tsx
// module id = 1071
// module chunks = 0 1 2